import React, { useCallback, useState } from "react";
import { SortByProps } from "@usereactify/search";
import { FilterChevron } from "./FilterChevron";

export type FilterSortByProps = React.ComponentProps<
  NonNullable<SortByProps["render"]>
>;

export const FilterSortBy: React.FC<FilterSortByProps> = (props) => {
  const [open, setOpen] = useState(false)
  const toggleFilter = useCallback(() => setOpen(!open), [open])
  
  return (
    <div className={`rs__filter fade-in ${open && "open" || ""}`}>
      <div className="rs__filter-heading" onClick={toggleFilter}>
        <span>
          Sort By
        </span>

        <FilterChevron />
      </div>

      <ul className="rs__filter__list">
        {props.sortOptions.map((sortOption) => (
          <li
            key={sortOption.handle}
            className="rs__sortby__option rs__filter__list-item"
            value={sortOption.handle}
            onClick={(event) => props.setSortOption(sortOption.handle)}
          >
            {sortOption.name}
          </li>
        ))}
      </ul>
    </div>
    // <select
    //   className="rs__sortby__select"
    //   value={props.sortOption?.handle}
    //   onChange={(event) => props.setSortOption(event.target.value)}
    // >
    //   {props.sortOptions.map((sortOption) => (
    //     <option
    //       key={sortOption.handle}
    //       className="rs__sortby__option"
    //       value={sortOption.handle}
    //     >
    //       {sortOption.name}
    //     </option>
    //   ))}
    // </select>
  );
};
